import React, { useState } from 'react';
import { dashboardSummariesCount, spendAnalysisRevenue, totalRevenueSales, bussinessRevenue, topSellingProducts, salesByState, paymentMode, dashboardKpiCategory, bussinessRevenueCount,topSellingCategory } from '../../../../services/dashboardHome';

const useDashboardHome = () => {
  const [loadingRevenue, setLoadingRevenue] = useState(false);
  const [loadingSpend, setLoadingSpend] = useState(false);
  const [dashboardSummary, setDashboardSummary] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState([]);
  const [spendAnlysis, setSpendAnlysis] = useState([]);
  const [revenueBussiness, setRevenueBussiness] = useState([]);
  const [paymentModeState, setPaymentModeState] = useState([]);
  const [SalesByState, setSalesByState] = useState([]);
  const [SalesByStateLoaded, setSalesByStateLoaded] = useState(false);
  const [topSellingProductsState, setTopSellingProductsState] = useState([]);
  const [topSellingCategoryState, setTopSellingCategoryState] = useState([]);
  const [topSellingProductsStateLoaded, setTopSellingProductsStateLoaded] = useState(false)
  const [topSellingCategoryStateLoaded, setTopSellingCategoryStateLoaded] = useState(false)

  const [totalRevenueFilter, setTotalRevenueFilter] = useState('daily');
  const [spendAnlysisFilter, setSpendAnlysisFilter] = useState('daily');
  const [revenueBussinessCount,setRevenueBussinessCount]= useState([]);
  const [loadingState, setLoadingState] = useState({
    revenueBussiness: false,
    revenueBussinessCount:false,
    salesByState: false,
    topSellingProductsState:false,
    topSellingCategoryState:false,
    dashboardSummary:false,
    paymentModeState:false
  })

  const getDashboardSummaryCard = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev)=>({
      ...prev,
      dashboardSummary:true
    }))
    try {
      let response = await dashboardSummariesCount({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setDashboardSummary(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
        console.error('Failed dashboard summary API calling :',error)
    }
    finally{
      setLoadingState((prev)=>({
        ...prev,
        dashboardSummary:false
      }))
    }
  }

  const getTopSellingProducts = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev)=>({
      ...prev,
      topSellingProductsState:true
    }))
    setTopSellingProductsStateLoaded(false); 
    try {
      let response = await topSellingProducts({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setTopSellingProductsState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
        console.error("Failed top selling products API calling :", error);
    } finally {
      setLoadingState((prev)=>({
        ...prev,
        topSellingProductsState:false
      }))
      setTopSellingProductsStateLoaded(true); 
    }
  }

    const getTopSellingCategory = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev)=>({
      ...prev,
      topSellingCategoryState:true
    }))
    setTopSellingCategoryStateLoaded(false); 
    try {
      let response = await topSellingCategory({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setTopSellingCategoryState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
        console.error("Failed top selling products API calling :", error);
    } finally {
      setLoadingState((prev)=>({
        ...prev,
        topSellingCategoryState:false
      }))
      setTopSellingCategoryStateLoaded(true); 
    }
  }

  const getSalesByState = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev) => ({
      ...prev,
      salesByState: true
    }))
    setSalesByStateLoaded(false)
    try {
      let response = await salesByState({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setSalesByState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    }catch(err){
      console.error("sales by state api calling faild:", err);
    }
    finally {
        setLoadingState((prev) => ({
        ...prev,
        salesByState: false
      }))
      setSalesByStateLoaded(true); 
    }
  }

  const getPaymentMode = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev)=>({
      ...prev,
      paymentModeState:true
    }))
    try {
      let response = await paymentMode({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setPaymentModeState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error('Failed payment mode API calling :',error)
    }
    finally{
      setLoadingState((prev)=>({
        ...prev,
        paymentModeState:false
      }))
    }
  }
  const getBussinessRevenue = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev) => ({
      ...prev,
      revenueBussiness: true
    }))
    try {
      let response = await bussinessRevenue({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setRevenueBussiness(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        revenueBussiness: false
      }))
    }
  }
    const getBussinessRevenueCount = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev) => ({
      ...prev,
      revenueBussinessCount: true
    }))
    try {
      let response = await bussinessRevenueCount({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setRevenueBussinessCount(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        revenueBussinessCount: false
      }))
    }
  }
  
    const getDashboardKpiCategory = async ({ formattedEnd, formattedStart }) => {
    setLoadingState((prev) => ({
      ...prev,
      revenueBussiness: true
    }))
    try {
      let response = await dashboardKpiCategory({ formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setRevenueBussiness(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        revenueBussiness: false
      }))
    }
  }

  const getSpendAnlysisRevenue = async ({ spendAnlysisFilter, formattedEnd, formattedStart }) => {
    setLoadingSpend(true);
    try {
      let response = await spendAnalysisRevenue({ spendAnlysisFilter, formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setSpendAnlysis(response.data);
        setLoadingSpend(false);
      } else {
        setLoadingSpend(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoadingSpend(false);
    }
  }

  const getTotalRevenueSales = async ({ totalRevenueFilter, formattedEnd, formattedStart }) => {
    setLoadingRevenue(true);
    try {
      let response = await totalRevenueSales({ totalRevenueFilter, formattedEnd, formattedStart });
      if (response && response.success && response.data) {
        setTotalRevenue(response.data);
        setLoadingRevenue(false);
      } else {
        setLoadingRevenue(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoadingRevenue(false);
    }
  }

  return {
    loadingRevenue,
    loadingSpend,
    dashboardSummary,
    totalRevenue,
    spendAnlysis,
    revenueBussiness,
    SalesByState,
    topSellingProductsState,
    topSellingCategoryState,
    topSellingCategoryStateLoaded,
    getBussinessRevenue,
    getDashboardSummaryCard,
    getTotalRevenueSales,
    getSpendAnlysisRevenue,
    getTopSellingProducts,
    getTopSellingCategory,
    getSalesByState,
    totalRevenueFilter,
    spendAnlysisFilter,
    setTotalRevenueFilter,
    setSpendAnlysisFilter,
    paymentModeState,
    getPaymentMode,
    topSellingProductsStateLoaded, SalesByStateLoaded,
    loadingState,
    getDashboardKpiCategory,
    revenueBussinessCount,
    getBussinessRevenueCount
  };
};

export default useDashboardHome;
